module.exports = __webpack_public_path__ + "img/sensor-en.23fb0b0a.svg";